module.exports = __webpack_public_path__ + "static/media/clockface-night.20ffce0d.png";